$(document).ready(function(){
    $('.Search__Form').on('submit', function(e){
        e.preventDefault();
        if($(this).find('input[name="q"]').val() === "puer" || $(this).find('input[name="q"]').val() === "Puer"){
          var term = "pu'er";

        }else if($(this).find('input[name="q"]').val() === "puer black" || $(this).find('input[name="q"]').val() === "puer black tea" || $(this).find('input[name="q"]').val() === "pu'er black" || $(this).find('input[name="q"]').val() === "Puer Black"){
          var term = "pu'erh-black";
          
        }else if($(this).find('input[name="q"]').val() === "puer green" || $(this).find('input[name="q"]').val() === "puer green tea" || $(this).find('input[name="q"]').val() === "pu'er green" || $(this).find('input[name="q"]').val() === "Puer Green"){
          var term = "pu'erh-green";
          
        }else if($(this).find('input[name="q"]').val() === "btox" || $(this).find('input[name="q"]').val() === "beauty" || $(this).find('input[name="q"]').val() === "electrolyte" || $(this).find('input[name="q"]').val() === "electrolytes" || $(this).find('input[name="q"]').val() === "fountain" || $(this).find('input[name="q"]').val() === "hydrate"){
          var term = "B•T";
          
        }else if($(this).find('input[name="q"]').val() === "holi" || $(this).find('input[name="q"]').val() === "hoji"){
          var term = "Holi Hoji";
        }
        else{
          var term = $(this).find('input[name="q"]').val();
        }
        var linkURL = '/search?type=product&q=' + term;
        window.location = linkURL;
      });
  });
    $(document).ready(function(){
      $(".Search__Input").on("input", function(){
          // Print entered value in a div box
          if($(this).val() === "puer" || $(this).val() === "Puer"){
           $(this).val("pu'er")
          }
          else if($(this).val() === "puer green" || $(this).val() === "Puer green" || $(this).val() === "puer green tea"){
           $(this).val("pu'er green")
          }
          else if($(this).val() === "puer black" || $(this).val() === "Puer black" || $(this).val() === "puer black tea"){
           $(this).val("pu'er black")
          }
          else if($(this).val() === "btox" || $(this).val() === "botox" || $(this).val() === "bt" || $(this).val() === "Bt" || $(this).val() === "BT" || $(this).val() === "btf" || $(this).val() === "b•tf"){
            $(this).val("b•t")
          }
          else if($(this).val() === "VC" || $(this).val() === "vc" || $(this).val() === "Vc"){
           $(this).val("daily radiance")
          }
          if($(this).val() === "xe" || $(this).val() === "xef" || $(this).val() === "X•Ef"){
            $(this).val("X•E")
          }
          if($(this).val() === "ref" || $(this).val() === "Ref"){
            $(this).val("R•E")
          }
      });
      $('.Search__Input').on('keyup touchend', function(){
        if($(this).val() === "REF" || $(this).val() === "botox" || $(this).val() === "bt" || $(this).val() === "Bt" || $(this).val() === "BT" || $(this).val() === "btf"){
            $(this).val("b•t")
          }
        if($(this).val() === "btox" || $(this).val() === "Ref"){
            $(this).val("R•E")
          }
          if($(this).val() === "xe" || $(this).val() === "xef"){
            $(this).val("X•E")
          }
      });
  });

if ((window.innerWidth > 768 ))  {
  $(".Search__Input").on("input", function(){
  $('.Search__Results').insertBefore('.Search');
  $('#shopify-section-header').css('z-index','10');
   $('.PageOverlay').addClass('is-visible');
    if($(this).val().length === 0){
      $('.Search__Results').attr('aria-hidden','false');
      $('.PageOverlay').removeClass('is-visible');
      $('#shopify-section-header').css('','');
      $('.Search__Close').css('display','none');
      setTimeout( function() { $('.Search__Close').hide() },500);
    }else{
      setTimeout( function() { $('.Search__Close').show() },1000);
    }
});
  
  $('.Search__Close').click( function(){
     $('.Search__Results').attr('aria-hidden','true');
      $(this).css('display','none');
  })
  }